import React from 'react';
import { Form, FormField } from '../../../shared/components/form_components/form';
import { InputForm } from '../../../shared/components/form_components/input';
import { TextAreaForm } from '../../../shared/components/form_components/field';
import { FormGroup } from '../../../shared/components/form_components/group';

interface Props {
  disciplina?: FormDisciplina;
  onSubmit: (disciplina: FormDisciplina) => void;
  onCancel?: () => void;
}

interface FormDisciplina {
  id_disciplina?: number;
  dsc_nome_disciplina: string;
  dsc_sigla: string;
  dsc_ementa: string;
  num_carga_horaria: number;
}

const FormularioDisciplina: React.FC<Props> = (props) => {
  const fields: FormField[] = [
    {
      name: 'id_disciplina',
      label: 'Id da Disciplina',
      type: 'number',
      defaultValue: props.disciplina?.id_disciplina,
      required: true,
      disabled: true,
      component: InputForm,
    },
    {
      name: 'dsc_nome_disciplina',
      label: 'Nome da Disciplina',
      type: 'text',
      defaultValue: props.disciplina?.dsc_nome_disciplina,
      required: true,
      component: InputForm,
    },
    {
      name: 'group_sigla_ch',
      type: 'group',
      sub_fields: [
        {
          name: 'dsc_sigla',
          label: 'Sigla',
          type: 'text',
          defaultValue: props.disciplina?.dsc_sigla,
          required: true,
          component: InputForm,
        },
        {
          name: 'num_carga_horaria',
          label: 'Carga Horária',
          type: 'number',
          defaultValue: props.disciplina?.num_carga_horaria,
          required: true,
          component: InputForm,
        },
      ],
      component: FormGroup,
    },
    {
      name: 'dsc_ementa',
      label: 'Ementa',
      type: 'text',
      defaultValue: props.disciplina?.dsc_ementa,
      maxLength: 1000,
      component: TextAreaForm,
    },
  ];

  return (
    <Form
      fields={fields}
      form_name='disciplina'
      is_edit={Boolean(props.disciplina)}
      onSubmit={props.onSubmit}
      onCancel={props.onCancel}
    />
  );
};

export { FormularioDisciplina };
export type { FormDisciplina };
